// The login view (was login.tpl). Posts JSON to /ui/login instead of the form
// POST to /login, then hands over to the shell.
import loginHtml from '../views/login.html?raw';
import { mount, escapeHtml } from './tpl.js';
import { T } from './i18n.js';
import { login } from './session.js';
import { renderBackendPicker } from './backend-picker.js';

export function renderLogin(sess, onLoggedIn) {
  const app = document.getElementById('app');
  const ctx = Object.assign({}, sess, { login: sess.login || {} });
  mount(app, loginHtml, ctx);
  renderBackendPicker(app);

  const cfg = ctx.login;
  // guest mode: big buttons first, the form hidden behind a "work here" link
  if (cfg.guestmode) {
    document.body.classList.add('wb-login-guest');
    const buttons = document.getElementById('wbGuestButtons');
    buttons.innerHTML = (cfg.buttons || [])
      .map((b) => '<a type="button" class="btn btn-primary btn-block" href="' + escapeHtml(b.href) + '">' + escapeHtml(b.prompt) + '</a>')
      .join('');
    const links = document.getElementById('wbGuestLinks');
    links.innerHTML = (cfg.links || [])
      .map((l) => '<a class="wbworkhere" href="' + escapeHtml(l.href) + '">' + escapeHtml(l.prompt) + '</a>')
      .join('');
    links.querySelectorAll('a.wbworkhere').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.remove('wb-login-guest');
      });
    });
  } else {
    document.body.classList.remove('wb-login-guest');
  }

  if (new URLSearchParams(window.location.search).get('fail') === 'true') {
    showBadCredentials();
  }

  const form = document.getElementById('wbLoginForm');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const button = document.getElementById('WBLoginButton');
    button.disabled = true;
    try {
      const username = form.elements.username.value;
      const password = form.elements.password.value;
      const result = await login(username, password);
      if (result && result.ok) {
        await onLoggedIn();
        return;
      }
      window.bootbox.alert(result && result.msg ? result.msg : T('Login failed.'));
    } catch (err) {
      if (err.status === 401) showBadCredentials();
      else window.bootbox.alert(err.message || T('Login failed.'));
    } finally {
      button.disabled = false;
    }
  });
}

function showBadCredentials() {
  window.bootbox.dialog({
    title: T('Invalid credentials'),
    message: T('The userID or password you entered is incorrect, please try again.'),
    closeButton: false,
    buttons: {
      okay: {
        label: T('OK'),
        className: 'btn-primary',
        callback: function () {},
      },
    },
  });
}
